// extracted by mini-css-extract-plugin
export default {"IndicatorWrapper":"CarouselCustom_IndicatorWrapper__IQter","CarouselIndicator":"CarouselCustom_CarouselIndicator__eF5VM","Active":"CarouselCustom_Active__5W63M"};